module.exports = __webpack_public_path__ + "img/costa-sol-rent-logo.6c60af51.png";